(function () {
  var MQ = window.matchMedia('(max-width: 749px)');

  function placeButtons(steps) {
    var carousel = steps.parentElement && steps.parentElement.parentElement;
    if (!carousel) return;
    var slide = steps.querySelector('.swiper-slide-active') || steps.querySelector('.how-it-works__step');
    var media = slide && slide.querySelector('.how-it-works__media');
    if (!media) return;
    var top = slide.offsetTop + media.offsetTop + media.offsetHeight / 2;
    carousel.querySelectorAll('.how-it-works__button').forEach(function (button) {
      button.style.top = top + 'px';
    });
  }

  function enable(steps) {
    if (steps.dataset.swiperOn === 'true' || typeof Swiper === 'undefined') return;

    var swiperEl = document.createElement('div');
    swiperEl.className = 'swiper js-how-it-works-swiper';
    steps.parentNode.insertBefore(swiperEl, steps);
    swiperEl.appendChild(steps);

    var carousel = document.createElement('div');
    carousel.className = 'how-it-works__carousel';
    swiperEl.parentNode.insertBefore(carousel, swiperEl);
    carousel.appendChild(swiperEl);

    steps.classList.add('swiper-wrapper');
    steps.querySelectorAll('.how-it-works__step').forEach(function (step) {
      step.classList.add('swiper-slide');
    });

    ['prev', 'next'].forEach(function (direction) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'how-it-works__button how-it-works__button--' + direction;
      button.setAttribute('aria-label', direction === 'prev' ? 'Slide left' : 'Slide right');
      button.innerHTML = direction === 'prev'
        ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      carousel.appendChild(button);
    });

    steps._howSwiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      watchOverflow: true,
      navigation: {
        prevEl: carousel.querySelector('.how-it-works__button--prev'),
        nextEl: carousel.querySelector('.how-it-works__button--next'),
      },
      on: {
        init: function () {
          placeButtons(steps);
        },
        slideChangeTransitionEnd: function () {
          placeButtons(steps);
        },
        resize: function () {
          placeButtons(steps);
        },
      },
    });
    steps.dataset.swiperOn = 'true';
  }

  function disable(steps) {
    if (steps.dataset.swiperOn !== 'true') return;
    if (steps._howSwiper) {
      steps._howSwiper.destroy(true, true);
      steps._howSwiper = null;
    }
    steps.classList.remove('swiper-wrapper');
    steps.querySelectorAll('.how-it-works__step').forEach(function (step) {
      step.classList.remove('swiper-slide');
      step.removeAttribute('style');
    });
    steps.removeAttribute('style');
    var swiperEl = steps.parentElement;
    var carousel = swiperEl && swiperEl.parentElement;
    if (carousel && carousel.classList.contains('how-it-works__carousel')) {
      carousel.parentNode.insertBefore(steps, carousel);
      carousel.remove();
    }
    steps.dataset.swiperOn = 'false';
  }

  function sync(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-how-it-works]').forEach(function (steps) {
      if (MQ.matches) enable(steps);
      else disable(steps);
    });
  }

  function start(scope) {
    var tries = 0;
    function attempt() {
      if (typeof Swiper === 'undefined') {
        tries += 1;
        if (tries < 40) window.setTimeout(attempt, 50);
        return;
      }
      sync(scope || document);
    }
    attempt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start(document);
    });
  } else {
    start(document);
  }

  if (MQ.addEventListener) {
    MQ.addEventListener('change', function () {
      sync(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });
})();
